/**
* @license Apache-2.0
*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

// MODULES //

import format from '@stdlib/string/format';
import kernels from './kernels.js';


// MAIN //

/**
* Returns the specified kernel function.
*
* @private
* @param {string} name - kernel name
* @returns {(Function|Error)} kernel function or corresponding error
*/
function getKernel( name ) {
	var kernel = kernels[ name ];
	if ( kernel === void 0 ) {
		return new Error( format( 'invalid argument. Unsupported/unrecognized kernel. Value: `%s`.', name ) );
	}
	return kernel;
}


// EXPORTS //

export default getKernel;
